import axios from "axios";

import api from "./apiService";

const EmpresaService = {
    buscaTodasAsEmpresas: async (limite = 500) => {
        let res = await api.get("/empresa/admin", {
            params: {
                limite,
            },
        });
        return res.data;
    },

    cadastrarEmpresa: async (empresa) => {
        let res = await api.post("/empresa/admin", empresa);
        return res.data;
    },

    atualizarEmpresa: async (empresa) => {
        let res = await api.put("/empresa/admin", empresa);
        return res.data;
    },

    buscarEmpresa: async (id) => {
        let res = await api.get(`/empresa/admin/${id}`);
        return res.data;
    },

    buscarEmpresas: async (pagina = 1, limite = 10, busca = undefined) => {
        const params = [];

        if (pagina && pagina != "") {
            params.push(`pagina=${pagina}`);
        }

        if (limite && limite != "") {
            params.push(`limite=${limite}`);
        }

        if (busca && busca != "") {
            params.push(`busca=${busca}`);
        }

        const search = params.length > 0 ? `?${params.join("&")}` : "";

        const res = await api.get(`/empresa/admin${search}`);

        return {
            empresas: res.data,
            total: res.headers["x-total-count"],
        };
    },

    buscarCep: async (cep) => {
        const res = await axios
            .create({
                baseURL: "https://brasilapi.com.br/api/cep/v2/",
                timeout: 2000,
            })
            .get(cep);

        return res.data;
    },
};

export default EmpresaService;
